import { initializeApp } from 'firebase/app'
import { getAuth, isSignInWithEmailLink } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

import Logger, { EventName, LogLevel, ProviderType } from '@/wrappers/logger'

import useToken from '../hooks/useToken'

// Initialize Firebase
const app = initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
})

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

export const refreshToken = async () => {
  let user = auth.currentUser

  if (user === null) {
    // User null, check if auth state is ready (mostly when refresh page)
    await auth.authStateReady()
    user = auth.currentUser
  }

  if (user === null) {
    // User still null, sign out
    signOut()
    window.location.pathname = '/login'
    Logger.addLog(
      EventName.FIREBASE_ERROR,
      {
        data: {
          context: 'Firebase user null',
          action: 'refreshToken'
        }
      },
      {
        isAction: true,
        logLevel: LogLevel.ERROR
      },
      [ProviderType.DATADOG]
    )
    return
  }
  const token = await user?.getIdToken(true)

  const expirationTime = (await user.getIdTokenResult()).expirationTime

  const { setToken } = useToken()

  setToken(token, expirationTime)
}

export const isSignInWithEmail = () =>
  isSignInWithEmailLink(auth, window.location.href)

// Initialize Cloud Firestore and get a reference to the service
export const firestore = getFirestore(app)

export const signOut = async () => {
  await auth.signOut()
}
